// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2zmdg","legacyBtn":"MutateMid_legacyBtn__2D5BY"};